module.exports = __webpack_public_path__ + "static/media/MapaReparto.d8a6ad99.png";